export const zhCN = {
  ANSWER: {
    CARRIER: {
      "3PL": "第三方物流",
      BREAD: "面包类",
      COKE: "可口可乐产品",
      DSD: "店铺直接配送",
      FLOWERS: "鲜花",
      GFS: "GFS",
      LCL: "拼箱运输",
      MEAT: "肉类",
      PEPSI: "百事可乐产品",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "承包商",
      DELIVERY: "送货",
      FLEET_DRIVER: "车队司机",
      GULFSTREAM: "Gulfstream",
      MAINTENANCE: "维护",
      PERSONAL_VEHICLE: "私人车辆",
      SERVICE: "服务",
      SHUNT_DRIVER: "调车司机",
      SHUTTLE_DRIVER: "接驳车司机",
    },
    DUNNAGE: {
      "1_2": "1/2",
      "1_4": "1/4",
      FULL: "满载",
    },
    ENTRY_PURPOSE: {
      BOBTAIL: "无挂车",
      CARRIER_LOADED: "承运商已装货",
      CONTRACTOR: "合约承运商",
      CONTRACTOR_VISITOR: "合约承运商/访客",
      DELIVERY: "送货",
      DROP: "卸货",
      DROP_HOOK: "放挂",
      EMPTY: "空载",
      EMPTY_TRAILER: "空挂车",
      FOODBANK: "食品银行",
      FUEL: "燃料",
      LIVE_LOAD: "现场装货",
      LOADED: "已装货",
      NFI_LOADED: "NFI 已装货",
      OTHERS: "其他",
      PARKING: "停车",
      PICKUP_EMPTY: "提货空车",
      PICKUP_LOAD: "提货装货",
      PICK_UP: "提货",
      PLANT_LOADED: "已在工厂装货",
      PRIVATE: "私人",
      REPAIR: "维修",
      VISITOR: "访客",
      WAAS_FAAS: "仓库即服务 / 货运即服务",
      WASH: "清洗",
    },
    ENTRY_TYPE: {
      INBOUND: "入站",
      INBOUND_ARRIVAL: "入站 / \n到达",
      INBOUND_DROP: "入站 / 卸货",
      MAINTENANCE: "维护",
      OUTBOUND: "出站",
      OUTBOUND_DEPARTURE: "出站 / \n发车",
      OUTBOUND_PICKUP: "出站 / 提货",
      WALMART_CARRIERS: "沃尔玛承运商",
      YARD_STORAGE: "堆场储存",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "40": "40",
      "48": "48",
      "53": "53",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "无挂车",
      CHASSIS: "底盘",
      CONTAINER: "集装箱",
      TRAILER: "挂车",
      VAN: "厢式货车",
    },
    FUEL_LEVEL: {
      "1_2": "1/2",
      "1_4": "1/4",
      "1_8": "1/8",
      "3_4": "3/4",
      "3_8": "3/8",
      "5_8": "5/8",
      "7_8": "7/8",
      EMPTY: "空载",
      FULL: "满载",
    },
    GENERIC: {
      NO: "否",
      YES: "是",
    },
    LOADED_STATUS: {
      EMPTY: "空载",
      LOADED: "已装货",
    },
    LOAD_DETAILS: {
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
      DRY: "干货车",
      FROZEN: "冷冻车",
      HEAT: "加热车",
      "MULTI TEMP": "多温控货车",
      REEFER: "冷藏车",
    },
    LOAD_TYPE: {
      BOBTAIL: "无挂车",
      EMPTY: "空载",
      LOADED: "已装货",
      OTHERS: "其他",
    },
    REEFER: {
      OFF: "关",
      ON: "开",
    },
    TRAILER_TYPE: {
      DRY: "干货车",
      REEFER: "冷藏车",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "卸货即走",
      DROP_AND_WAIT: "卸货并等待",
      DROP_EMPTY: "卸货空车",
      PICKUP_EMPTY: "提货空车",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "由 EAIGLE 开发",
    INVALID_FACILITY: "找不到设施！",
    PAGE_NOT_FOUND: "找不到页面。无效参数",
    PLEASE_ROTATE: "请将设备旋转为竖屏模式，以使用此应用程序。",
    POWERED_BY_EAIGLE: "由 <LOGO/> eaigle.com 提供技术支持",
  },
  AVAC: {
    ADD_COMMENT_HEADER: "添加备注（必填）",
    AREA: {
      ISO: "ISO",
      TANK_WASH: "储罐清洗",
    },
    COMMENT_HERE: "在此添加备注…",
    COMMENT_SUBMITTED: "已提交备注",
    DETAILS: {
      ACTUAL_TEMPERATURE: "实际温度",
      ADDITIONAL_COMMENTS: "附加评论",
      ALLOCATED_PAD: "预分配库存（Allocated PAD）",
      APPOINTMENT_INFORMATION: "预约信息",
      APPOINTMENT_NUMBER: "预约编号",
      APPOINTMENT_TIME: "预约时间",
      APPOINTMENT_TYPE: "预约类型",
      AVAC_EVENT: "AVAC 事件",
      BOL_NUMBER: "提单号",
      BOOKING_NUMBER: "订舱号",
      BRE_STATUS: "BRE 状态",
      BROKER: "代理",
      CARRIER: "承运商",
      CARRIER_NAME: "承运商名称",
      CHASSIS_NUMBER: "底盘编号",
      CHILD_SCAC: "子 SCAC 编码",
      COMMENT: "备注",
      CVIP_DATE: "CVIP 日期",
      CV_DETAILS: "CV 详情",
      CV_EVENT_ID: "CV 事件识别号",
      DELIVERY_NOTE: "送货单",
      DESCRIPTION: "描述",
      DRIVER_ENGAGEMENT_TIME: "司机实操耗时（秒）",
      DRIVER_INFORMATION: "司机信息",
      DRIVER_NAME: "司机姓名",
      DUNNAGE: "垫料",
      ENTRY_SUBTYPE: "入场子类型",
      ENTRY_TYPE: "入场类型",
      EQUIPMENT_LENGTH: "设备长度",
      EQUIPMENT_LOADED_STATUS: "设备装货状态",
      EQUIPMENT_TYPE: "设备类型",
      EQUIPMENT_TYPE_ID: "设备类型识别号",
      EVENT_ID: "事件识别号",
      EVENT_INFORMATION: "事件信息",
      EVENT_TIME: "事件时间",
      EVENT_TYPE: "事件类型",
      FAILURE_REASON: "失败原因",
      FIRST_NAME: "名字",
      FUEL_LEVEL: "燃油量",
      GATE_ENGAGEMENT_TIME: "门岗接货时间（秒）",
      ID: "识别号",
      IMAGES: "图像",
      LANE_ID: "通道识别号",
      LANE_NAME: "通道名称",
      LAST_NAME: "姓氏",
      LIVE_DROP: "现场卸货",
      LOAD_ID: "装货识别号",
      LTL: "零担运输",
      MC_NUMBER: "承运人号码",
      OPERATOR_COMMENTS: "操作员备注",
      ORDER_NUMBER: "订单号",
      PARENT_SCAC: "上级 SCAC 编码",
      PHONE_NUMBER: "电话号码",
      PLATE_NUMBER: "车牌号",
      PO: "采购订单",
      PO_LOAD_DETAILS: "采购订单 / 装货明细",
      PO_NUMBER: "采购订单号",
      RAIL_CARS: "铁路货车",
      REFERENCE_NUMBER: "参考号",
      SCAC: "SCAC 码",
      SEAL_NUMBER: "封条号",
      SET_TEMPERATURE: "设定温度",
      SPOT_NUMBER: "车位号",
      START_TIME: "开始时间",
      STATUS: "状态",
      TEMPERATURE: "温度",
      TIMESTAMP: "时间戳",
      TRACTOR_ID: "牵引车识别号",
      TRACTOR_NUMBER: "牵引车车牌号",
      TRAILER: "挂车",
      TRAILER_NUMBER: "挂车号码",
      TRAILER_TYPE: "挂车类型",
      TRUCK_INFORMATION: "卡车信息",
      TRUCK_NUMBER: "卡车编号",
      UNIT: "车组",
      UNIT_ID: "车组识别号",
      UNIT_NUMBER: "车组编号",
      UNIT_TYPE: "车组类型",
      USDOT_NUMBER: "美国交通部编号",
      VEHICLE_MEDIA: "车辆媒体资料",
      VIDEOS: "视频",
      WAC: "仓库区域代码 (WAC)",
      ZONE: "区",
    },
    DRIVER_ASSIST: "司机辅助功能",
    DRIVER_CREATED: "司机创建成功！",
    DRIVER_PIN: "司机 PIN 码：",
    DRIVER_QR_CODE: "司机二维码",
    DRIVER_UPDATED: "司机更新成功！",
    ERROR: {
      ACCESS_DENIED: "拒绝访问",
      ACCESS_DENIED_DETAILS: "无权访问该模块。",
      AUTH_ERROR: "身份验证错误：{{ERROR}}",
      CONTACT_ADMIN: "请联系管理员以获取权限。",
      ERROR_CREATING_DRIVER: "创建司机时发生错误",
      ERROR_UPDATING_DRIVER: "更新司机时发生错误",
      FAILED_TO_CREATE_DRIVER: "未能创建司机",
      FAILED_TO_FETCH_FACILITIES: "未能获取设施信息",
      FAILED_TO_UPDATE_DRIVER: "未能更新司机",
      LOADING_EVENT_DETAILS_AVAC: "加载事件详情时出错。正在重定向到 AVAC…",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "加载事件详情时出错。正在重定向到门岗登录 (Gate Log) 页面…",
      MISSING_EMAIL_AND_PHONE_NUMBER: "请提供电子邮箱地址或电话号码",
      NO_FACILITY_SELECTED: "未选择任何设施",
      WEBSOCKET_ERROR: "WebSocket 错误：{{ERROR}}",
    },
    FACILITY: "设施",
    FAILED_EVENTS: "失败事件",
    HISTORICAL_EVENTS: "历史事件（最近一天）",
    IMAGE_MODAL_INSTRUCTIONS: "要通过滚动来缩放吗？缩放后可拖动平移",
    NEW_DRIVER: {
      PIN_SENT: "已向司机的电子邮箱和手机号发送了 PIN 码。",
      QR_CODE_AND_PIN_SENT: "已向司机的电子邮箱和手机号发送了二维码和 PIN 码。",
      QR_CODE_SENT: "已向司机的电子邮箱和手机号发送了二维码。",
    },
    NO_APPROVED_EVENTS: "在所选的日期范围内未找到已批准的事件",
    NO_EVENTS: "无可用事件",
    NO_FAILED_EVENTS: "未找到最近一天的失败事件",
    NO_INVENTORY: "未找到库存项。",
    NO_LANES: "无可用通道。",
    NO_MATCHES: "未找到匹配项",
    NO_NON_FAILURE_EVENTS: "未找到最近一天的非故障事件",
    NO_VEHICLE_MEDIA: "无可用车辆媒体资料",
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "阅读并同意 <BUTTON>免责声明表</BUTTON>",
    SELECT_LANE: "选择通道",
    SUBMITTING: "正在提交…",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "请填写电子邮箱或电话号码字段",
    },
    TOAST: {
      APPROVE_EVENT_FAILED: "事件未通过审批。请重试。",
      EVENT_APPROVED: "事件审批成功！点击“开门”按钮。",
      EVENT_REJECTED: "已拒绝事件。",
      GATE_OPENED: "已成功开门！",
      OPEN_GATE_FAILED: "未能开门。请重试或联系支持人员。",
      REJECT_EVENT_FAILED: "未能拒绝事件。请重试。",
    },
    VALIDATING_ACCESS: "正在验证访问权限…",
    VALIDATION: {
      INVALID_EMAIL: "请输入有效的电子邮箱地址",
      INVALID_NAME: "仅可包含字母和空格",
      INVALID_PHONE_NUMBER: "请输入有效的 10 位数电话号码",
    },
  },
  BRE: {
    FAILED_TO_OPEN_GATE: "未能开门",
    GATE_OPEN_FAILED: "未能开门",
    INVALID_APPOINTMENT: "无效预约",
    DRIVER_REGISTRATION_EXPIRED: "司机登记无效。请联系门岗操作员。",
    INVALID_QRCODE_FORMAT: "二维码格式无效",
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "已超出预约使用次数上限",
      BOL_CALL_FAILED: "调用提单失败",
      BOL_CALL_FAILED_NO_LANE_EVENT: "调用提单失败，或者未找到 InProgress CVLaneEvent",
      BOL_PO_MISSING: "预约中缺少提单号 / 采购订单号",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "预约中缺少提单号 / 采购订单号，且未找到 InProgress CVLaneEvent",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent 不存在",
      EVENT_OUTSIDE_OPERATION_HOURS: "事件发生在运营时间之外",
      FAILED_OBTAIN_BOL_INFO: "未能获取提单信息",
      FUEL_LEVEL_BELOW_THRESHOLD: "燃油量低于 0.75，且未找到 InProgress CVLaneEvent",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "燃油量低于 0.75，且未找到 InProgress CVLaneEvent",
      INTERNAL_FAILURE: "内部故障",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "预约入场子类型无效",
      INVALID_APPOINTMENT_ENTRY_TYPE: "预约入场类型无效",
      INVALID_APPOINTMENT_QR_CODE: "预约二维码无效",
      INVALID_ENTRY_SUBTYPE: "入场子类型无效",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "预约中的入场子类型无效",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "预约中的入场子类型无效，且未找到 InProgress CVLaneEvent",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER: "入站无挂车的车牌号无效",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE: "出站空车预约使用无效",
      INVALID_QRCODE_SOURCE: "二维码来源无效",
      MAX_APPOINTMENT_LIMIT_REACHED: "已达到预约使用上限",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "未找到 CV LaneEvent，或者预约不受支持且与使用情况不匹配",
      NO_INPROGRESS_LANE_EVENT_FOUND: "未找到 InProgress LaneEvent",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "未找到 InProgress LaneEvent，或者记录中已有挂车号码",
      NO_USER_INFO_RECEIVED: "未收到用户信息",
      NO_VEHICLE_DETECTED: "未检测到车辆或车辆类型无效",
      NO_VEHICLE_DETECTED_BOBTAIL: "未检测到车辆，或者车辆并非无挂车",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "请前往装卸平台办公室",
      SEAL_NUMBER_MISMATCH: "封条号不匹配",
      SEAL_NUMBER_MISSING: "已装货出站的记录中缺少封条号",
      TEMPERATURE_EXCEEDS_LIMIT: "温度超出限制",
      TEMPERATURE_INFO_MISSING: "缺少温度信息，且由于当前季节，无法跳过温度检查",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "缺少温度信息，且由于当前季节，无法跳过温度检查。未找到 InProgress CVLaneEvent",
      TEMPERATURE_INFO_NOT_INCLUDED: "预约中未包含温度信息",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "预约中未包含温度信息，且未找到 InProgress CVLaneEvent",
      TRAILER_NUMBER_DOES_NOT_MATCH: "挂车号码不匹配。",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD: "挂车号码与记录不匹配",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "挂车号码不可用",
      TRAILER_NUMBER_MISSING: "挂车号码缺失或与记录不匹配",
      TRAILER_NUMBER_NOT_PRESENT: "预约中未提供挂车号码",
      TRAILER_NUMBER_SHOULD_NOT_EXIST: "记录中不应存在挂车号码",
      UNABLE_TO_VALIDATE_TEMPERATURE: "无法验证温度",
      UNSUPPORTED_APPOINTMENT_TYPE: "预约类型不受支持且不匹配",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "预约不存在",
      OFF_HOURS_OUTBOUND_TRAILER: "在非工作时间，挂车出站时应使用对讲机",
      OUTBOUND_TRAFFIC_WORKING_HOURS: "在工作时间，出站车辆应使用对讲机",
      YMS_CHECKIN_FAILED: "堆场管理系统 (YMS) 入场登记失败。请联系门岗操作员",
    },
    LOBLAW: {
      ENTRY_APPROVED: "已批准入场。请前往停靠区 {{MESSAGE}}",
      INVALID_INFORMATION: "无效信息",
      PROCEED_TO_DISPATCH: "{{MESSAGE}} 请前往调度办公室了解详情",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} 下次见",
    },
    PORTCITY: {
      AFTER_HOURS_ENTRY:
        "若要在非工作时间入场，请使用中间车道的数字键盘。由您的调度提供代码",
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "提供的订舱号无效",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Eaigle 预约记录无效",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL: "个人资料无效或凭证已过期",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "这不是出站的无挂车",
      IT_IS_NOT_A_BOBTAIL: "这不是无挂车",
      LOADID_PROVIDED_IS_NOT_VALID: "提供的装货识别号无效",
      NO_BOOKING_NUMBER_PROVIDED: "未提供订舱号",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "未找到 InProgress CV LaneEvent",
      NO_LOADID_PROVIDED: "未提供装货识别号",
      PICK_UP_BOL: "{{MESSAGE}} 请在 25 号门领取提单",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE: "请联系安保人员开门",
      UNSUPPORTED_APPOINTMENT_TYPE: "不支持的预约类型",
      UNSUPPORTED_OPERATION_TYPE: "不支持的操作类型",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "无效的请求",
    },
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}}（{{NAME}}）",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}}) ",
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "实际温度",
    ACTUAL_TEMPERATURE_F: "实际温度（华氏度）",
    COMPANY: "公司信息",
    EQUIPMENT_DETAILS: "设备详细信息",
    LOAD_DETAILS: "装货明细",
    PERSONAL: "个人信息",
    PURPOSE_DETAILS: "目的详情",
    SAFETY: "安全性",
    SET_TEMPERATURE: "设定温度",
    SET_TEMPERATURE_F: "设定温度（华氏度）",
    SHIPPING_DETAILS: "运输详情",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "未经验证的运输详情",
    SHIPPING_DETAILS_WITH_VALIDATION: "已验证的运输详情",
    VEHICLE_EQUIPMENT_DETAILS: "车辆 / 设备详情",
    VISIT_PURPOSE: "来访目的",
  },
  COMMAND: {
    ADD_NEW_DRIVER: "新增司机",
    APPROVE: "批准",
    BACK: "返回",
    BACK_TO_EVENTS: "返回事件",
    CHECK_IN: "入场登记",
    CHECK_OUT: "出场登记",
    CLEAR: "清除",
    CLICK_TO_EDIT: "点击编辑",
    CLOSE: "关闭",
    CLOSE_IMAGE_MODAL: "关闭图片弹窗",
    DELETE: "删除",
    EDIT: "编辑",
    LOGOUT: "退出登录",
    NEXT: "下一步",
    OPEN_GATE: "开门",
    REJECT: "拒绝",
    RETURN: "返回",
    SELECT_END: "选择结束",
    SELECT_START: "选择开始",
    SSO_LOGIN: "使用 Azure AD 登录",
    START_NEW_REGISTRATION: "开始新的注册",
    SUBMIT: "提交",
    TODAY: "今天",
    UPDATE: "更新",
  },
  DAY: {
    "0": "周日",
    "1": "周一",
    "2": "周二",
    "3": "周三",
    "4": "周四",
    "5": "周五",
    "6": "周六",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "浏览器不支持视频标签。",
  },
  ERROR_MODAL: {
    INVALID_X: "{{TITLE}} 无效",
  },
  EVENT_STATUS: {
    APPROVED: "已批准",
    FAILURE: "故障",
    INPROGRESS: "正在进行",
    REJECTED: "已拒绝",
    SUCCESS: "成功",
  },
  FAILURE_PAGE: {
    BODY: "请按下自助终端上的对讲机按钮",
    FAILURE: "故障",
    HEADER: "信息未经验证！",
    INTERCOM: "对讲机",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "事件类型",
      STATUS: "状态",
      TIME: "时间",
      TRAILER_LOGO: "挂车徽标",
    },
    EVENT_TYPE: {
      JB_HUNT: "J.B. Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "清洁",
      DIRTY: "脏污",
      EMPTY: "空载",
      INBOUND: "入站",
      LOADED: "已装货",
      OUTBOUND: "出站",
    },
    TIME: {
      LAST_24_HOURS: "过去 24 小时",
      LAST_MONTH: "过去一周",
      LAST_WEEK: "过去一个月",
      LAST_YEAR: "过去一年",
      TODAY: "今天",
    },
  },
  FORM_INPUT: {
    COMMAND: {
      ENTER_SCAC: "点击即可手动输入 SCAC 编码",
      SELECT_SCAC: "点击即可从可用的 SCAC 编码中选择",
      SHOW_LESS: "显示较少信息",
      SHOW_MORE: "显示更多信息",
    },
    FIELD_IS_REQUIRED: "此字段必填",
    NO_MATCHES: "未找到匹配项",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "搜索或选择…",
    SELECT_CARRIER: "搜索或选择承运商…",
    SELECT_DATE: "选择日期",
    SELECT_OPTIONS: "选择选项…",
    TRUNCATED: "{{TEXT}}…",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "下一步",
      SUBMIT: "提交",
    },
    ERROR: {
      UNABLE_TO_SUBMIT: "无法提交表。请稍后重试。",
    },
    VALIDATING: "正在验证…",
  },
  HINT: {
    EDIT_SEAL_NUMBER: "* 如有需要，编辑已填写的封条号。",
    LOAD_ID_8_DIGITS: "装货识别号是以 4 开头的 8 位数字",
    SCAC_NOT_LISTED_CPU9: "如果列表中没有您的 SCAC 编码，请输入 CPU9。",
  },
  IDCAPTURE: {
    CAMERA_ERROR: {
      BODY: "无法访问您的摄像头。请检查权限并重试。",
      HEADER: "摄像头访问权限错误",
    },
    COMMAND: {
      CAPTURE: "拍摄证件",
      CAPTURING: "正在拍摄…",
      CHANGE_TYPE: "更改证件类型",
      DONE: "完成",
      RETAKE_PHOTOS: "重拍照片",
      SUBMIT: "提交",
      SWITCH_CAMERA: "切换摄像头",
      TRY_AGAIN: "请重试",
      TRY_BACK: "请尝试后置摄像头",
      TRY_FRONT: "请尝试前置摄像头",
    },
    EMPLOYEE_ID_BACK: "员工证（背面）",
    EMPLOYEE_ID_BACK_ALT: "员工证的背面",
    EMPLOYEE_ID_FRONT: "员工证（正面）",
    EMPLOYEE_ID_FRONT_ALT: "员工证的正面",
    ERROR: {
      EXPIRED: "证件已过期。请提供有效证件。",
      GENERIC: "出现错误",
      NO_CAMERA: "无法使用摄像头。请连接摄像头或尝试其他浏览器。",
      NO_SWITCH: "无法切换其他摄像头，因为只有一个视频设备可用。",
      PERMISSION_DENIED: "权限被拒。请刷新并授予摄像头权限。",
      UNREADABLE: "无法读取证件信息。",
      UNSUPPORTED: "不支持画布功能。",
      UPLOAD_FAILED: "上传员工证图像失败",
      UPLOAD_FAILED_TRY_AGAIN: "上传员工证图像失败。请重试。",
      VERIFY_FAILED_TRY_AGAIN: "无法验证证件。请重试。",
    },
    ID_INFORMATION: "证件信息",
    ID_NOT_VERIFIED_MESSAGE: "无法充分验证您的证件。请检查以下详细信息。",
    ID_NOT_VERIFIED_STATUS: "证件验证问题",
    ID_VERIFIED_MESSAGE: "已成功验证您的身份。",
    ID_VERIFIED_STATUS: "证件验证成功",
    INSTRUCTIONS: {
      DRIVERS_LICENSE: "将驾驶证置于框架内，并确保光线充足。",
      EMPLOYEE_ID_BACK: "现在将员工证背面置于框架内。",
      EMPLOYEE_ID_FRONT: "将员工证正面置于框架内。",
    },
    PROCESSING: "正在处理…",
    SELECT_TYPE: "选择证件类型",
    TYPE: {
      DRIVERS_LICENSE: "驾驶证",
      EMPLOYEE_ID: "员工证",
    },
  },
  IMAGE_PREVIEW: {
    CAPTURED_ID: "已拍摄的证件",
    COMMAND: {
      RETAKE: "重拍",
      SUBMIT: "提交",
    },
    PLEASE_WAIT: "正在验证您的信息，请稍候",
    PROCESSING_ID: "正在处理您的证件…",
    SUBMITTING: "正在提交…",
    TIP: "请确保图片清晰可读。",
  },
  KIOSK: {
    COMMAND: {
      ENTER: "输入",
      REGISTER_NOW: "立即注册",
    },
    ERROR: {
      CONNECTION_CLOSED: "连接已关闭",
      CONNECTION_ERROR: "连接错误",
      ENTRY_TYPE_INVALID: "入场类型“{{TYPE}}”无效",
      ENTRY_TYPE_MISSING: "缺少入场类型",
      FAILED_TO_CONNECT: "无法连接建立",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM: "信息未经验证！使用对讲机",
      INTERACTION_TYPE_INVALID: "交互类型“{{TYPE}}”无效",
      INTERACTION_TYPE_MISSING: "缺少交互类型",
      INTERMITTENT_CONNECTION:
        "间歇性连接错误\n如果问题一直存在，请联系 EAIGLE 支持人员：1 888 771 1584",
      INTERMITTENT_CONNECTION_N:
        "间歇性连接错误 {{N}}；如果问题一直存在，请联系 EAIGLE 支持人员：1 888 771 1584",
      MISSING_REQUIRED_INFO: "缺少必填信息",
      PROCESSING_ERROR: "处理请求时出错。使用对讲机",
      VALIDATION_FAILED: "验证过程失败",
      VALIDATION_TIMEOUT: "验证超时",
    },
    FOOTER: {
      NOT_REGISTERED: "尚未注册？",
    },
    GATE_OPEN: "门已打开",
    INFORMATION_VERIFIED: "已验证信息！",
    INVALID_URL_PARAMETERS: "URL 参数无效",
    KEY: {
      BACKSPACE: "退格键",
      CLEAR: "清除",
      CLOSE: "关闭",
    },
    KEY_PAD_INSTRUCTIONS: "输入一次性密码",
    PLEASE_ROTATE_LANDSCAPE: "请将设备旋转到横屏模式",
    PLEASE_WAIT_X: "请稍候。{{TEXT}}",
    PRE_REGISTERED: "已预先注册？",
    PROCEED_TO_EXIT: "请前往出口",
    PROCEED_TO_ZONE: "前往指定区域",
    REDIRECTING: "正在重定向…",
    SCAN_QR_CODE: "将已预先注册的<br/>二维码对准自助终端<br/>进行扫描。",
    SECONDS_REMAINING: "剩余 {{N}} 秒",
    TROUBLE_SCANNING_QR_CODE: "扫描二维码时遇到问题 ― 点击此处手动输入预约码",
    VALIDATION: {
      PERSON_NAME: "仅限字母和空格",
      PHONE_NUMBER: "例如：1234567890",
    },
    VERIFYING_INFORMATION: "正在验证信息…",
    VIDEO_NOT_AVAILABLE: "无法观看直播视频",
    WAIT_VERIFY_INFO: "正在验证您的信息，请稍候",
    WAIT_VERIFY_QR: "请等待二维码通过验证",
  },
  LABEL: {
    APPROVED: "已批准",
    AREA: "区域",
    CARRIER: "承运商",
    CHECK_ICON: "勾选图标",
    CHECK_IN_TIME: "入场登记时间",
    CHECK_OUT_TIME: "出场登记时间",
    DETENTION_TIME: "滞留时间",
    INDICATORS: "指示器",
    DETENTION_TIME_HOURS: "滞留时间（小时）",
    DRIVERS: "司机",
    DURATION: "时长",
    ERROR_ICON: "错误图标",
    FIRST_NAME_LAST_NAME: "{{LAST}}{{FIRST}}",
    FROM_DATE_TIME_TZ: "起始时间：{{DATE_TIME_TZ}}",
    GATE_LOG: "门岗日志",
    GATE_OPEN: "已打开门",
    LOCATION: "位置",
    NOT_APPLICABLE: "不适用",
    OPENING: "正在打开…",
    REGISTRATION: "注册",
    ROW: "行",
    SECTION_N: "第 {{N}} {{SECTION}}",
    SPOT: "车位",
    STEP_N: "第 {{N}} 步",
    TANKER: "油罐车",
    TIME: "时间",
    TIME_STAMP: "时间戳",
    TOTAL_RECORDS_N: "总记录数： {{N}}",
    TO_DATE_TIME_TZ: "至： {{DATE_TIME_TZ}}",
    UNIT_1: "车组 1",
    UNIT_HISTORY: "车组历史记录",
    UNIT_ID: "车组识别号",
    UNIT_TYPE: "车组类型",
    YARD_CHECK: "堆场检查",
    YARD_INVENTORY: "堆场库存",
    ZOOMABLE_TYPE: "可缩放 {{TYPE}}",
  },
  MONTH: {
    "1": "一月",
    "2": "二月",
    "3": "三月",
    "4": "四月",
    "5": "五月",
    "6": "六月",
    "7": "七月",
    "8": "八月",
    "9": "九月",
    "10": "十月",
    "11": "十一月",
    "12": "十二月",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "上一步",
    },
    DRIVER_REGISTRATION: "司机注册",
    LOGO: "徽标",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "验证",
    },
    ENTER_PASSCODE: "输入密码",
    ERROR: {
      INVALID_PASSCODE: "密码无效",
    },
  },
  PLACEHOLDER: {
    ACTUAL_TEMPERATURE_F: "实际温度（华氏度）",
    BOL_OR_PO_NUMBERS: "提单 / 采购订单",
    BOOKING_NUMBER: "订舱号",
    CARRIER: "承运商",
    CARRIER_NAME_PARENT_SCAC: "承运商名称（上级承运商 SCAC 编码）",
    CARRIER_SCAC: "输入承运商 SCAC 编码",
    COMPANY_NAME: "公司名称",
    CURRENT_TEMPERATURE_F: "当前温度（华氏度）",
    CVIP_DATE: "CVIP 日期",
    DRIVER_FIRST_NAME: "司机名字",
    DRIVER_LAST_NAME: "司机姓氏",
    DRIVER_NAME: "司机姓名",
    DRIVER_TYPE: "司机类型",
    DUNNAGE: "垫料",
    EMAIL: "电子邮件",
    EMAIL_ADDRESS: "电子邮箱地址",
    ENTRY_TYPE_REASON: "入场类型（来访原因）",
    EQUIPMENT_LENGTH: "设备长度",
    EQUIPMENT_LOADED_STATUS: "设备装货状态",
    EQUIPMENT_TYPE: "设备类型",
    FIRST_NAME: "名字",
    FUEL_LEVEL: "燃油量",
    ID_VALIDATION: "识别号验证",
    I_AGREE: "我同意",
    LAST_NAME: "姓氏",
    LOAD_ID: "装货识别号",
    LOAD_ID_NUMBER: "装货识别编号",
    OUTBOUND_BOL: "出站提单",
    PHONE_NUMBER: "电话号码",
    PO_NUMBER: "采购订单号",
    PO_NUMBER_OR_LOAD_ID: "采购订单号、发货通知单号或装货识别号/参考编号",
    PPE_DOCK_SAFETY: "个人防护装备与装卸平台安全",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "如需装卸平台安全方面的协助，或对个人防护装备有任何疑问，请联系检查站的指定人员。 \n\n谢谢",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "选择“是”即表示您同意遵守所有适用的法律和我们的政策。禁止未经授权的使用、修改或分发。我们不对任何损害负责。欲了解更多信息，请查阅我们的《隐私政策》和完整条款。\n\n如果未遵守装卸平台安全或个人防护装备方面的要求，可能会面临罚款。如需装卸平台安全方面的协助，或对个人防护装备有任何疑问，请联系检查站的指定人员。",
    REASON_FOR_ENTRY: "入场原因",
    REEFER_FUEL_LEVEL: "冷藏机燃油量",
    REEFER_ON: "冷藏机开 / 关",
    SEAL_NUMBER: "封条号",
    SEARCH_CARRIER: "搜索承运商…",
    SELECT_FACILITY: "选择设施…",
    SELECT_X: "选择{{X}}",
    SIGNATURE: "签名",
    TEMPERATURE_F: "温度（华氏度）",
    TRACTOR_CARRIER_NAME: "牵引车承运商名称",
    TRACTOR_NUMBER: "牵引车车牌号",
    TRAILER_CARRIER_NAME: "挂车承运商名称",
    TRAILER_MIDDLE: "中部",
    TRAILER_NOSE: "前端",
    TRAILER_NUMBER: "挂车号码",
    TRAILER_TAIL: "尾部",
    TRAILER_TYPE: "挂车类型",
    VALIDATION_PERIOD: "验证期",
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "实际温度（华氏度）",
    APPOINTMENT_DETAILS: "预约详情",
    COMPANY_INFO: "公司信息",
    CONFIRM_SEAL_AND_TRAILER_NUMBER: "确认封条完好，且挂车号码正确",
    CONFIRM_TRAILER_CONDITION: "确认挂车内无杂物，双轴可滑装置已后移，冷藏机正常运行。",
    DRIVER_NAME: "输入司机姓名",
    DRIVER_TYPE: "司机类型",
    ENTRY_PURPOSE: "选择入场目的",
    ENTRY_TYPE: "选择入场类型",
    EQUIPMENT_DETAILS: "设备详细信息",
    GENERIC: "填写信息",
    LOAD_DETAILS: "装货明细",
    LOAD_TYPE: "选择装货类型",
    PERSONAL_INFO: "个人信息",
    PPE_DOCK_SAFETY: "个人防护装备与装卸平台安全",
    SET_TEMPERATURE_F: "设定温度（华氏度）",
    SHIPPING_DETAILS: "运输详情",
    VEHICLE_DETAILS: "车辆详情",
    VISIT_TYPE: "选择访问类型",
    WAIVER: "豁免",
  },
  STATUS: {
    ACTIVE: "有效",
    EXPIRED: "已过期",
    EXPIRING_SOON: "即将过期",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "下载",
      EMAIL: "电子邮件",
      HOME: "首页",
      MESSAGE: "消息",
      START_OVER: "重新开始",
    },
    DRIVER_CHECK_IN_SUCCESS: "已成功启动入场登记",
    DRIVER_CHECK_OUT_SUCCESS: "已成功启动出场登记",
    GENERATING_QR_CODE: "正在生成二维码！",
    PLEASE_CHECK_DASHBOARD: "请查看 AVAC 仪表盘了解状态",
    PLEASE_SCAN_CODE: "请扫描自助终端上的二维码。",
    PLEASE_WAIT: "请稍候…",
    QR_CODE_GENERATED: "已生成二维码！",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "请填写采购单号或装货识别号字段",
  },
  TITLE: {
    CARRIER: "承运商",
    CATEGORY: "类别",
    COMPANY_NAME: "公司名称",
    EMAIL_ADDRESS: "电子邮箱地址",
    ENTRY_SUB_TYPE: "入场子类型",
    ENTRY_TYPE: "入场类型",
    FIRST_NAME: "名字",
    LAST_NAME: "姓氏",
    PHONE_NUMBER: "电话号码",
    REASON_FOR_ENTRY: "入场原因",
    REFERENCE_NUMBER: "参考号",
    SEAL_NUMBER: "封条号",
    SIGNATURE: "签名",
    TEMPERATURE: "温度",
    TRAILER_NUMBER: "挂车号码",
    VALIDATION_PERIOD: "验证期",
  },
  TOOLTIP: {
    ADD: "添加",
    ARROW: "箭头",
    COMPANY_LOGO: "公司徽标",
    DOWNLOAD: "下载",
    LOGO: "徽标",
    MENU: "菜单",
    SORT_ASC: "升序排列",
    SORT_DESC: "降序排列",
  },
  VALIDATION: {
    EMAIL_ADDRESS: "请输入有效的电子邮箱地址",
    ERROR: {
      BOL_VALIDATION_FAILED: "验证参考号失败。",
      FUEL_VALIDATION_FAILED: "无法获取冷藏车统计数据",
      INVALID_BOOKING_NUMBER: "订舱号无效",
      INVALID_FACILITY: "设施无效",
      INVALID_LOAD_ID: "装货识别号无效",
      LOAD_ID_VALIDATION_FAILED: "装货编号验证失败",
      PO_VALIDATION_FAILED: "采购订单无效。请重试或联系入站职员。",
      TRAILER_VALIDATION_FAILED: "无法验证挂车详细信息",
    },
    FLOAT: "请输入有效数字（例如 123 或 123.45）",
    NUMERIC: "请仅可输入数字",
    PERSON_NAME: "仅可包含字母和空格",
    PHONE_NUMBER: "电话号码格式错误",
    PO_NUMBER_OR_LOAD_ID: "请提供采购订单号或装货识别号",
    TEMPERATURE_FROM_N20F_TO_P100F: "温度必须介于华氏 -20 度至 100 度之间",
    VALIDATING_REFERENCE_NUMBER: "正在验证参考号",
    VALIDATING_TRAILER_DETAILS: "正在验证挂车详细信息",
  },
} as const;
